module.exports = __webpack_public_path__ + "e623a69c2c715916a8df26f7994624ee.svg";